<script>
export default {
  name: "NotificationsViewer",
}

</script>

<template>
  <div id="section-0" class="container">

    <div class="userSearch">
      <h1>Notificaciones</h1>


    </div>
  </div>


</template>

<style>


</style>